import { useRouter } from 'next/router';
import { match } from 'path-to-regexp';

import {
  LIST,
  LIST_BY_RUBRICS,
  LIST_BY_TAGS,
  LIST_PARTNERS,
  LIST_PARTNERS_WITH_TYPE,
  MFO_LIST_PARTNERS_WITH_TYPE,
} from '../constants/routes';
import { preparePath } from '../helpers/seo';
import { PAGE_TYPE } from '../interfaces/routes';

export const useIsMainPage = () => {
  const { asPath } = useRouter();

  return /^\/mag\/?(\?.*)?$/.test(asPath);
};

const config = [
  [LIST, PAGE_TYPE.MAIN],
  [LIST_BY_RUBRICS, PAGE_TYPE.RUBRIC],
  [LIST_BY_TAGS, PAGE_TYPE.TAG],
  [LIST_PARTNERS_WITH_TYPE, PAGE_TYPE.PARTNER],
  [MFO_LIST_PARTNERS_WITH_TYPE, PAGE_TYPE.PARTNER],
  [LIST_PARTNERS, PAGE_TYPE.PARTNERS],
] as const;

export const usePageType = () => {
  const { asPath } = useRouter();

  const [, type] = config.find(([path]) => match(path)(preparePath(asPath))) || [];

  return type;
};
